import {
  rowDelimiter,
  colDelimiter,
  keyValueDelimiter,
  decode,
  encode,
  isEmpty,
} from "./genericHelper";

export const propNames = {
  numberOfTimes: "numberOfTimes",
  dropdown1: "dropdown1",
  date: "date",
  text1: "text1",
  text2: "text2",
  yesNo1: "yesNo1",
  dropdown2: "dropdown2",
  text3: "text3",
  date2: "date2",
  yesNo2: "yesNo2",
  text4: "text4",
  date3: "date3",
  yesNo3: "yesNo3",
};

export const transformInput = (id, val) => {
  let returnObj = {};
  let numberOfTimes;
  if (val) {
    numberOfTimes = val.slice(0, val.indexOf("]") + 1).slice(1, -1);
    const strippedHosp = val.replace(val.slice(0, val.indexOf("]") + 1), "");
    returnObj = { ...returnObj, [`${id}-numberOfTimes`]: numberOfTimes };
    const rows = strippedHosp.split(rowDelimiter);

    if (rows.length) {
      rows.forEach(async (el, index) => {
        if (el && el !== "") {
          const cols = el.split(colDelimiter);
          if (cols.length > 0) {
            cols.forEach((col) => {
              const keyValueArr = col.split(keyValueDelimiter);

              if (keyValueArr.length > 0) {
                const key = keyValueArr[0];
                let value = keyValueArr[1];
                if (value && value !== "") {
                  if ([propNames.date, propNames.date2, propNames.date3].includes(key)) {
                    value = new Date(value);
                  }
                  // eslint-disable-next-line max-len
                  if ([propNames.text1, propNames.text2, propNames.text3, propNames.text4].includes(key)) {
                    value = decode(value);
                  }
                  if ([propNames.dropdown1, propNames.dropdown2].includes(key)) {
                    value = decode(value);
                  }
                  returnObj = {
                    ...returnObj,
                    [`${id}-${index}-${key}`]: value,
                  };
                }
              }
            });
          }
        }
      });
    }
  }
  return { numberOfTimes, responses: returnObj };
};

export const transformOutput = (id, value, responseCollection, options) => {
  let returnVal = "";
  let isInComplete = false;
  const numberOfTimes = value;
  if (numberOfTimes < 0 || numberOfTimes === null || numberOfTimes === undefined
  ) {
    isInComplete = true;
  }
  if (numberOfTimes > 0) {
    [...Array(numberOfTimes)].forEach((el, index) => {
      const idPrefix = `${id}-${index}-`;

      const dropdown1 = encode(responseCollection[`${idPrefix}${propNames.dropdown1}`]) || "";
      const date = responseCollection[`${idPrefix}${propNames.date}`];
      const text1 = encode(responseCollection[`${idPrefix}${propNames.text1}`]) || "";
      const text2 = encode(responseCollection[`${idPrefix}${propNames.text2}`]) || "";
      const yesNo1 = responseCollection[`${idPrefix}${propNames.yesNo1}`] || "";

      const dropdown2 = encode(responseCollection[`${idPrefix}${propNames.dropdown2}`]) || "";
      const text3 = encode(responseCollection[`${idPrefix}${propNames.text3}`]) || "";
      const date2 = responseCollection[`${idPrefix}${propNames.date2}`];
      const yesNo2 = responseCollection[`${idPrefix}${propNames.yesNo2}`] || "";

      const text4 = encode(responseCollection[`${idPrefix}${propNames.text4}`]) || "";
      const date3 = responseCollection[`${idPrefix}${propNames.date3}`];
      const yesNo3 = responseCollection[`${idPrefix}${propNames.yesNo3}`] || "";

      const isDropdown1Empty = (options?.dropdown1Show && isEmpty(dropdown1));
      const isDateEmpty = options?.dateShow && isEmpty(date);
      const isText1Empty = (options?.text1Show && isEmpty(text1));
      const isText2Empty = (options?.text2Show && isEmpty(text2));
      const isYesNo1Empty = (options?.yesNo1Show && isEmpty(yesNo1));
      if (!isInComplete &&
          (isDropdown1Empty || isDateEmpty || isText1Empty || isText2Empty || isYesNo1Empty)
      ) {
        isInComplete = true;
      }

      // drilldown 1 NO questions
      const isYesNo3Empty = (options?.yesNo3Show && isEmpty(yesNo3));
      if (!isInComplete && yesNo1 === 'No' && isYesNo3Empty) {
        isInComplete = true;
      }

      // drilldown 1 YES questions
      const isDropdown2Empty = (options?.dropdown2Show && isEmpty(dropdown2));
      const isText3Empty = (options?.text3Show && isEmpty(text3));
      const isDate2Empty = options?.date2Show && isEmpty(date2);
      const isYesNo2Empty = (options?.yesNo2Show && isEmpty(yesNo2));
      if (!isInComplete && yesNo1 === 'Yes' &&
          (isDropdown2Empty || isText3Empty || isDate2Empty || isYesNo2Empty)
      ) {
        isInComplete = true;
      }

      // drilldown 2 YES questions
      const isText4Empty = (options?.text4Show && isEmpty(text4));
      const isDate3Empty = options?.date3Show && isEmpty(date3);
      if (!isInComplete && yesNo2 === 'Yes' && (isText4Empty || isDate3Empty)) {
        isInComplete = true;
      }

      let dateStr = "";
      let date2Str = "";
      let date3Str = "";
      try {
        dateStr = date ? date?.toISOString() : ``;
        if (yesNo1 === 'Yes') {
          date2Str = date2 ? date2?.toISOString() : ``;
        }
        if (yesNo2 === 'Yes') {
          date3Str = date3 ? date3?.toISOString() : ``;
        }
      } catch {
        isInComplete = true;
      }

      const dropdown1Column = `${propNames.dropdown1}${keyValueDelimiter}${dropdown1}`;
      const dateColumn = `${colDelimiter}${propNames.date}${keyValueDelimiter}${dateStr}`;
      const text1Column = `${colDelimiter}${propNames.text1}${keyValueDelimiter}${text1}`;
      const text2Column = `${colDelimiter}${propNames.text2}${keyValueDelimiter}${text2}`;
      const yesNo1Column = `${colDelimiter}${propNames.yesNo1}${keyValueDelimiter}${yesNo1}`;

      const dropdown2Column = `${colDelimiter}${propNames.dropdown2}${keyValueDelimiter}${dropdown2}`;
      const text3Column = `${colDelimiter}${propNames.text3}${keyValueDelimiter}${text3}`;
      const date2Column = `${colDelimiter}${propNames.date2}${keyValueDelimiter}${date2Str}`;
      const yesNo2Column = `${colDelimiter}${propNames.yesNo2}${keyValueDelimiter}${yesNo2}`;
      const drilldown1YesColumns = `${dropdown2Column}${text3Column}${date2Column}${yesNo2Column}`;

      const yesNo3Column = `${colDelimiter}${propNames.yesNo3}${keyValueDelimiter}${yesNo3}`;
      const drilldown1NoColumns = `${yesNo3Column}`;

      const drilldown1Columns = `${drilldown1YesColumns}${drilldown1NoColumns}`;

      const text4Column = `${colDelimiter}${propNames.text4}${keyValueDelimiter}${text4}`;
      const date3Column = `${colDelimiter}${propNames.date3}${keyValueDelimiter}${date3Str}`;
      const drilldown2YesColumns = `${text4Column}${date3Column}`;

      returnVal += `${dropdown1Column}${dateColumn}${text1Column}${text2Column}${yesNo1Column}${drilldown1Columns}${drilldown2YesColumns}${rowDelimiter}`;
    });
  }

  return {
    transformedValue: `[${numberOfTimes}]${returnVal.slice(0, -1)}`,
    isComplete: !isInComplete,
  };
};
